import {Pipe, PipeTransform} from '@angular/core';
import {L10nTranslateAsyncPipe} from 'angular-l10n';

@Pipe({
    name: 'l10n',
    pure: false,
    standalone: false
})
export class L10nPipe extends L10nTranslateAsyncPipe implements PipeTransform {}
